// Deterministic indicator math. Computed only from REVEALED candles => no look-ahead.

export function ema(candles, period) {
  const k = 2 / (period + 1);
  let prev = null;
  return candles.map((c, i) => {
    const price = c.close;
    if (i === 0) prev = price;
    else prev = price * k + prev * (1 - k);
    return { time: c.time, value: +prev.toFixed(2) };
  });
}

export function vwap(candles) {
  let cumPV = 0;
  let cumV = 0;
  return candles.map((c) => {
    const tp = (c.high + c.low + c.close) / 3;
    cumPV += tp * c.volume;
    cumV += c.volume;
    return { time: c.time, value: +(cumV ? cumPV / cumV : c.close).toFixed(2) };
  });
}

export function rsi(candles, period = 14) {
  const out = [];
  let avgGain = 0;
  let avgLoss = 0;
  for (let i = 0; i < candles.length; i++) {
    if (i === 0) {
      out.push({ time: candles[i].time, value: 50 });
      continue;
    }
    const change = candles[i].close - candles[i - 1].close;
    const gain = Math.max(change, 0);
    const loss = Math.max(-change, 0);
    if (i <= period) {
      avgGain = (avgGain * (i - 1) + gain) / i;
      avgLoss = (avgLoss * (i - 1) + loss) / i;
    } else {
      avgGain = (avgGain * (period - 1) + gain) / period;
      avgLoss = (avgLoss * (period - 1) + loss) / period;
    }
    const rs = avgLoss === 0 ? 100 : avgGain / avgLoss;
    const val = avgLoss === 0 ? 100 : 100 - 100 / (1 + rs);
    out.push({ time: candles[i].time, value: +val.toFixed(2) });
  }
  return out;
}

export function volumeData(candles) {
  return candles.map((c) => ({
    time: c.time,
    value: c.volume,
    color: c.close >= c.open ? "rgba(16,185,129,0.5)" : "rgba(239,68,68,0.5)",
  }));
}
